/**
 * @file Front Page.
 */

/**
 * Front Page functions.
 *
 * Runs js specific to the Front Page template.
 */
const vFrontPage = () => {
	import('../../components/hp-hero/hp-hero').then(({ default: vHpHero }) => { vHpHero(); });
	import('../../components/hp-about/hp-about').then(({ default: vHpAbout }) => { vHpAbout(); });
	import('../../components/hp-ig-grid/hp-ig-grid').then(({ default: vHpIgFeed }) => { vHpIgFeed(); });
	import('../../components/hp-carousel/hp-carousel').then(({ default: vHpCarousel }) => { vHpCarousel(); });
	import('../../components/hp-reviews/hp-reviews').then(({ default: vHpReviews }) => { vHpReviews(); });
};

if (document.readyState !== 'loading') {
	vFrontPage();
} else {
	document.addEventListener('DOMContentLoaded', vFrontPage);
}
